/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldEditor} from "./BaseFieldEditor";
import {service as RelationshipService} from "../../../Services/RelationshipService";
import autobind from "autobind-decorator";
import {FormControl} from "react-bootstrap";
import React from "react";

export class RelationshipFieldEditor extends BaseFieldEditor {
	constructor(props) {
		super(props)

		this.setInitialState({
			relationships: []
		});
	}

	componentDidMount() {
		RelationshipService.Get()
			.then((x) => {
				this.setState({relationships: x.result});
			});
	}

	@autobind
	_render() {
		return <FormControl
			as="select"
			placeholder="Select A Relationship"
			value={this.props.Value != null ? this.props.Value : ""}
			onChange={(x) => this.props.OnUpdate(x.target.value)}
		>
			<option value="">Select A Relationship</option>
			{
				this.state.relationships.map((x) => <option key={x.relationshipId}
				                                            value={x.relationshipId}>{x.name}</option>)
			}
		</FormControl>;
	}
}